import React from 'react';

const TicketNumberDefault = ({ number }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='209.207'
			height='107.359'
			viewBox='0 0 209.207 107.359'
		>
			<defs>
				<linearGradient
					id='swipe-gradient-ticket-confirmation'
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform='rotate(65)'
				>
					<stop offset='0' stop-color='#8060a9'>
						<animate
							id='ticket-confirmation-trans'
							dur='2s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color='#d4d7d8'>
						<animate
							id='ticket-confirmation-trans'
							dur='2s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
				<radialGradient
					id='prefix__radial-gradient'
					cx='.5'
					cy='.5'
					r='.567'
					gradientTransform='matrix(1 0 0 1.514 0 -.257)'
					gradientUnits='objectBoundingBox'
				>
					<stop offset='0' stop-color='#7b868c' />
					<stop offset='1' stop-color='#5b6670' />
				</radialGradient>
				<filter
					id='prefix__Gradient_Ticket_Fill'
					width='209.207'
					height='107.359'
					x='0'
					y='0'
					filterUnits='userSpaceOnUse'
				>
					<feOffset dx='1' dy='1' />
					<feGaussianBlur result='blur' stdDeviation='3' />
					<feFlood flood-opacity='.259' />
					<feComposite in2='blur' operator='in' />
					<feComposite in='SourceGraphic' />
				</filter>
			</defs>
			<g id='prefix__images-ticket' transform='translate(-491.001 -313.82)'>
				<g filter='url(#prefix__Gradient_Ticket_Fill)' transform='translate(491 313.82)'>
					<path
						id='prefix__Gradient_Ticket_Fill-2'
						fill='url(#prefix__radial-gradient)'
						className='ticket-confirmation'
						d='M7.607 0h165.511a31.676 31.676 0 0 0 5.513 9.049 22.711 22.711 0 0 0 8.063 5.133v60.3a33 33 0 0 0-8.063 6.136 35.167 35.167 0 0 0-5.513 8.738H7.607a23.541 23.541 0 0 0-4.13-8.381 32.238 32.238 0 0 0-7.99-6.493v-60.3a21.622 21.622 0 0 0 7.99-5.335A22.763 22.763 0 0 0 7.607 0z'
						data-name='Gradient Ticket Fill'
						transform='translate(12.51 8)'
					/>
				</g>
				{/* <path
					id='prefix__Path_2068'
					fill='#d4d7d8'
					d='M-6.393 0H12.4l104.61 89.359H-6.393a23.541 23.541 0 0 0-4.13-8.381 32.238 32.238 0 0 0-7.99-6.493v-60.3a21.622 21.622 0 0 0 7.99-5.335A22.763 22.763 0 0 0-6.393 0z'
					data-name='Path 2068'
					opacity='0.219'
					transform='translate(517.281 321.82)'
				/> */}
			</g>
			<text
				x='50%'
				y='60%'
				height='100%'
				text-anchor='middle'
				//alignment-baseline='middle'
				font-family='ProximaNova-Light'
				letter-spacing='0.7px'
				fill={'#ffffff'}
			>
				{`#${number}`}
			</text>
		</svg>
	);
};

export default TicketNumberDefault;
